<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <h4 class="card-title ">Filtros</h4>
                    </div>
                    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_at != null}">
                                        <label for="interval" class="bmd-label-floating">Intervalo</label>
                                        <date-picker
                                            range
                                            v-model="form.date_at"
                                            lang="pt-br"
                                            format="DD/MM/YYYY"
                                            placeholder="Escolha uma data"
                                            :not-after="form.end_at"
                                            >
                                        </date-picker>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="team_id" class="bmd-label-floating">Equipe</label>
                                        <model-list-select
                                                class="form-control"
                                                :list="teams"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.team_id">
                                        </model-list-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Gerar</button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import TypeProfiles from '@/services/modules/typeprofiles.service';
    import Utils from '@/services/utils.service';

    // 0
    export default {
        computed: {
            teams: {
                get() {
                    return this.$store.state.teams.itens;
                }
            },
        },
        data() {
            return {
                 validation: {
                     team_id: null,
                },
                type_profiles: [],
                form: {
                    team_id: null,
                    date_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    end_at: Vue.moment().add(40, 'days'),
                },
                referenceDates: [
                    { id : 'sale_date', name : 'Data da Venda'},
                    { id : 'due_date' , name : 'Data de Vencimento'},
                    { id : 'payday'   , name : 'Data de Pagamento'},
                ],
            };
        },
        methods: {
            onReset() {
                this.form = {
                    team_id: null,
                    date_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    end_at: Vue.moment().add(40, 'days'),
                };
            },
            onSubmit() {
                var self = this;
                var valid = true;

                self.validation = {
                    team_id: null
                };

                if (!self.form.date_at[0] || !self.form.date_at[1]) {
                    valid = false;
                    self.validation.date_at = 'Favor informar o intervalo desejado!';
                }


                if (valid) {
                    var serialize = JSON.stringify(self.form);
                    window.open("print-evaluations?form=" + serialize, '_blank');
                }
            },
            async getDataTeams() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('teams/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
        },
        created() {
            var self = this;
            self.getDataTeams();
        }
    }
</script>
